<template>
  <layout>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="10" md="8" lg="6" xl="4">
          <v-card class="elevation-1">
            <v-toolbar color="secondary" dark flat>
              <v-toolbar-title>{{ $t("visitor.form.title") }}</v-toolbar-title>
            </v-toolbar>
            <v-form ref="form" v-model="valid" @keyup.native.enter="register">
              <v-card-text>
                <v-col class="pa-0">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field :label="$t('visitor.form.firstname')" v-model="firstname" prepend-icon="mdi-account" type="text" />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field :label="$t('visitor.form.lastname')" v-model="lastname" prepend-icon="mdi-account" type="text" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field :label="$t('visitor.form.addr')" v-model="addr" prepend-icon="mdi-map-marker" type="text" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field :label="$t('visitor.form.zip')" v-model="zip" prepend-icon="mdi-map-marker" type="text" />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field :label="$t('visitor.form.city')" v-model="city" prepend-icon="mdi-map-marker" type="text" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field :label="$t('visitor.form.email')" :rules="rules.email" v-model="email" prepend-icon="mdi-email" type="text" />
                    </v-col>
                  </v-row>
                </v-col>
                <v-alert text color="info">
                  Die Einträge sind freiwillig. Die Teilnahme am Event ist auch ohne diese Angaben möglich.
                  Wenn Sie unten anklicken, erhalten Sie regelmässig Infos zu unseren Vorträgen.
                </v-alert>
                <v-row>
                    <v-col cols="12">
                      <v-checkbox v-model="checklist" label="Ich möchte regelmässig per E-Mail Informationen zu den 
                        öffentlichen Vorträgen der Psychiatrie Baselland bekommen."></v-checkbox>
                    </v-col>
                  </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="register()">{{ $t("visitor.form.submit") }}</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout>
</template>

<script>
// @ is an alias to /src
import Layout from "@/layouts/default";
import axios from "axios";
import { formMixin } from "@/helpers/mixins";

export default {
  name: "visitor",
  mixins: [formMixin],
  components: {
    Layout,
  },
  data() {
    return {
      valid: null,
      name: null,
      firstname: null,
      lastname: null,
      addr: null,
      zip: null,
      city: null,
      email: null,
      checklist: null
    };
  },
  computed: {},
  methods: {
    register() {
      if (this.$refs.form.validate())
        if (this.name || this.firstname || this.lastname || this.addr || this.zip || this.email || this.email) {
          axios
            .post(`/api/visitors`, {
              firstname: this.firstname,
              lastname: this.lastname,
              addr: this.addr,
              zip: this.zip,
              city: this.city,
              email: this.email,
              ref: this.$route.meta.customer,
              checklist: this.checklist? this.$route.meta.visitorKey: ""
            })
            .then(() => {
              this.addToLoc();

              let redirectUrl = "";
              if (this.$route.query.redirect) {
                redirectUrl = this.$route.query.redirect;
              }

              this.$router.push(redirectUrl);
            })
            .catch((error) => {
              let err = {
                message: "Undefined Error",
                color: "red",
              };
              if (error.data && error.data.message) {
                err.message = error.data.message;
              }

              this.$store.dispatch("showSnackMessage", err);
            });
        } else {
          this.addToLoc();
          let redirectUrl = "";
          if (this.$route.query.redirect) {
            redirectUrl = this.$route.query.redirect;
          }

          this.$router.push(redirectUrl);
        }
    },
    addToLoc() {
      let loc = JSON.parse(localStorage.getItem("s4all-loc") || "{}");
      if (!loc || !loc.visitorKeys) {
        loc = {
          app: "s4all",
          visitorKeys: [],
        };
      }
      
      if (!loc.visitorKeys.includes(this.$route.meta.visitorKey)) {
        loc.visitorKeys.push(this.$route.meta.visitorKey);
      }

      localStorage.setItem("s4all-loc", JSON.stringify(loc));
    },
  },
};
</script>
